import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Chip as MuiChip } from '@material-ui/core';
import MuiChipInput from 'material-ui-chip-input';

const getChipsFormatted = (chips) => {
  let result = [];

  if (chips && chips.length) {
    if (chips[0].label === undefined || chips[0].value === undefined)
      // IMPORTANT: chips format should be an array contains
      // if not (array contains only values) => force format to pattern below
      // the object like: { label: ..., value: ... }
      result = chips.map((item) => ({ label: item, value: item }));
    else result = chips;
  }

  return result;
};

const ChipInput = (props) => {
  const { value: data, onAdd, onDelete, customChips, ...others } = props;

  const [chips, setChips] = useState(getChipsFormatted(data));

  const handleAddChip = (chipToAdd) => {
    const newChip = { label: chipToAdd, value: chips.length + 1 };
    setChips([...chips, newChip]);
    if (onAdd) onAdd(newChip);
  };

  const handleDeleteChip = (chipToDelete, removedIndex) => {
    setChips(chips.filter((item, index) => index !== removedIndex));
    if (onDelete) onDelete(chipToDelete);
  };

  const chipRendererProps = {
    chipRenderer: customChips
      ? ({ value, handleClick, handleDelete }, key) => {
          return (
            <MuiChip
              key={key}
              onClick={handleClick}
              onDelete={handleDelete}
              label={value.label}
              {...customChips}
            />
          );
        }
      : null,
  };

  return (
    // Controlled Input
    <MuiChipInput
      value={chips}
      onAdd={(chip) => handleAddChip(chip)}
      onDelete={(chip, idx) => handleDeleteChip(chip, idx)}
      {...chipRendererProps}
      {...others}
    />
  );
};

ChipInput.defaultProps = {
  value: [],
  onAdd: () => {},
  onDelete: () => {},
  customChips: {},
};

ChipInput.propTypes = {
  value: PropTypes.array,
  onAdd: PropTypes.func,
  onDelete: PropTypes.func,
  customChips: PropTypes.object,
};

export default ChipInput;
